import React from 'react';
import OrderList from '../common/OrderList';
import { salesOrdersAPI } from '../../services/api';
import { FilePlus2 } from 'lucide-react';

export default function SalesOrders() {
  return (
    <OrderList
      title="Sales Orders"
      icon="🛒"
      api={salesOrdersAPI}
      basePath="/sales-orders"
      statuses={['Draft', 'Confirmed', 'Fulfilled', 'PartiallyFulfilled', 'Shipped', 'Closed', 'Cancelled']}
      numberField="order_number"
      partyField="customer_name"
      dateField="order_date"
      secondField="expected_date"
      secondLabel="Expected"
      reopenAPI={(id) => salesOrdersAPI.reopen(id)}
      convertActions={[
        { label: 'Invoice', icon: <FilePlus2 size={12} />, handler: (id) => salesOrdersAPI.convertToInvoice(id), redirectTo: (invoiceId) => `/invoices/${invoiceId}` },
      ]}
    />
  );
}
